<div
  class="report-preview-area"
  [ngClass]="{'report-preview-area-three-col' : numColumnsInReport === 3, 'report-preview-area-four-col' : numColumnsInReport === 4, 'report-preview-area-no-labels' : !isPromptSelected()}"
>
  @for (artifact of extractedArtifacts; track artifact.artifactId) {
    <div class="report-image-artifact-object">
      <div class="report-image-artifact-image">
        <div class="report-picture-thumbnail">
          @if (artifact.thumbnailImage) {
            <app-report-image
              class="report-picture-image"
              [src]="imageUrlFor(artifact)"
              [alt]="artifact.artifactName"
              (settled)="onImageSettled()"
            />
          }
          @else {
            <div class="default-image report-picture-missing">
              <span>
                {{'TRANS__HAS_IMAGES__NONE' | translate}}
              </span>
            </div>
          }
        </div>
      </div>

      @if (!isOnlyPhotosSelected()) {
        <h1>
          {{ artifact.artifactName }}
        </h1>

        @for (section of artifact.sections; track section.id) {
          @for (field of section.fields; track $index) {
            <div
              class="report-image-value-area"
              [ngClass]="{'report-image-value-area-one-col' : numColumnsInReport > 2}"
            >
              @for (value of field.value; track $index;) {
                @if(isPromptSelected()) {
                  <div
                    class="report-artifact-field-title"
                    [ngClass]="{'report-artifact-field-title-medium' : numColumnsInReport > 2}"
                  >
                    <span>
                      {{ field.key }}
                    </span>
                  </div>
                }

                <!-- HTML, as in the catalogue: names of invalid concepts come wrapped in <del>. -->
                <div
                  class="report-artifact-field-values-grid-right"
                  [innerHTML]="value.values"
                ></div>
              }
            </div>
          }
        }
      }
    </div>
  }
</div>
